import styled from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const DimOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 50% black for dimming */
  z-index: 1;
  border-radius: 15px;
`

export const IntroduceLabel = styled.img`
  width: 90%;
  position: absolute;
  top: 58%;
  left: 52%;
  transform: translate(-50%, -50%);
  z-index: 2;
`

export const VignetteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allow interactions to pass through */
  background: radial-gradient(
    circle,
    rgba(0, 0, 0, 0) 20%,
    /* Transparent center */ rgba(0, 0, 0, 0) 80%,
    /* Slightly dark mid-point */ rgba(0, 0, 0, 0.8) 100% /* Dark edges */
  );
  z-index: 2;
  border-radius: 15px;
`

export const Icon = styled.div`
  font-size: 4rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  z-index: 9999;
  display: none;

  &.play-button {
    display: flex;
  }

  &:hover {
    display: flex;
  }
`

export const VideoContainer = styled.div`
  position: relative;
  width: 225px;
  height: 400px;
  ${({ fullSize }) => fullSize && "height: 100%; width: 100%;"}

  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;

  iframe {
    border: 0;
    border-radius: 15px;
    height: 100%;
    width: 100%;
  }
`
export const VideoWrapper = styled.div`
  position: relative;
  height: 400px;
  width: 225px;
  margin: auto;
  cursor: pointer;
  ${({ fullSize }) => fullSize && "height: 100%; width: 100%;"}

  iframe {
    border-radius: 15px;
    pointer-events: none;
  }

  &:hover ${Icon} {
    display: flex !important;
  }
`
